// extracted by mini-css-extract-plugin
export default {"wrapper":"Сonditions_wrapper__9FklP","content":"Сonditions_content__MdixG"};